import { render, staticRenderFns } from "./DetailClass.vue?vue&type=template&id=37c53bba&"
import script from "./DetailClass.vue?vue&type=script&lang=js&"
export * from "./DetailClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports